 import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  defaultFont,
} from "assets/jss/material-dashboard-react.js";
import brandTheme from "brandTheme/Theme";

const tableStyle = (theme) => ({
  warningTableHeader: {
    color: warningColor[0],
  },
  primaryTableHeader: {
    color: primaryColor[0],
  },
  dangerTableHeader: {
    color: dangerColor[0],
  },
  successTableHeader: {
    color: successColor[0],
  },
  infoTableHeader: {
    color: infoColor[0],
  },
  roseTableHeader: {
    color: roseColor[0],
  },
  grayTableHeader: {
    color: grayColor[0],
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse",
    border: "2px solid #000000",
  },
  tableHeadCell: {
    color: "#ffffff",
    textAlign: "center",
    borderRight: "2px solid #000000",
    ...defaultFont,
    "&, &$tableCell": {
      fontSize: "1em",
      fontWeight: 400,
    },
  },
  tableContianer:{
    marginTop:"30px"
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.32857143",
    padding: 8,
    verticalAlign: "middle",
    fontSize: "0.9125rem",
    borderRight: "1px solid #000000",
    borderBottom: "1px solid #000000",
  },
  tableCellOrament:{
backgroundColor:'#d3d3d3',
border:'none',
textAlign:'center',
width:'200px',
  },
  tableCellDisbursal:{
    backgroundColor:'#d3d3d3',
border:'none',
"&:nth-child(0)": {
  width: "12%",
},
"&:nth-child(1)": {
  width: "14%",
},
"&:nth-child(2)": {
  width: "18%",
},
"&:nth-child(3)": {
  width: "22%",
},
"&:nth-child(4)": {
  width: "12%",
},
"&:nth-child(5)": {
  width: "12%",
},
"&:nth-child(6)": {
  width: "12%",
},

  },
  disbursalNew:{
    backgroundColor:'#d3d3d3',
    border:'none',
    width:'100%',
    textAlign:'left',
    padding:'0px 18px',
  },
  disbursalPostPledge:{
    backgroundColor:'#d3d3d3',
    border:'none',
    width:'100%',
    textAlign:'left',
    padding:'0 11px',
  },
  tableCellDisbursal1:{
    backgroundColor:'#d3d3d3',
    border:'none',
    width:"25%",
  },
  tableResponsive: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  tableHeadRowDisbursal: {
    height: 50,
    color: "#000",
    backgroundColor: "#808080",
    // textWeight:"bold",
    display: "flex",
    outline: "none",
    verticalAlign: "middle",
    border: "2px solid #000000",
  },
  tableBodyRowDisbursal: {
    // height: 70,
    color: "inherit",
    display: "flex",
    outline: "none",
    verticalAlign: "middle",
    border: "1px solid #000000",
  },
  disbursalPostPledges:{
    width:'16%',
    display: "block",
    padding: "5px",

  },
  cameraContainer:{
    '& video':{
      width:'300px',
      height:'180px'
    }
  },
  disbursalBT:{
    width:'25%',
    display: "block",
    padding: "5px",
  },
  tableHeadRow: {
    height: 50,
    color: "#000",
    backgroundColor: "#808080",
    // textWeight:"bold",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle",
    border: "2px solid #000000",
  },
  tableBodyRow: {
    height: 35,
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle",
    border: "1px solid #000000",
  },
  tableCellData:{
    display:"block",
    padding:'5px',
    "&:nth-child(0)": {
      width: "15%",
    },
    "&:nth-child(1)": {
      width: "15%",
    },
    "&:nth-child(2)": {
      width: "18%",
    },
    "&:nth-child(3)": {
      width: "17%",
    },
    "&:nth-child(4)": {
      width: "14%",
    },
    "&:nth-child(5)": {
      width: "12%",
    },
    "&:nth-child(6)": {
      width: "12%",
    },
    "@media (max-width:700px)":{
      "&:nth-child(0)": {
        width: "100px",
      },
      "&:nth-child(1)": {
        width: "100px",
      },
      "&:nth-child(2)": {
        width: "100px",
      },
      "&:nth-child(3)": {
        width: "100px",
      },
      "&:nth-child(4)": {
        width: "100px",
      },
      "&:nth-child(5)": {
        width: "100px",
      },
      "&:nth-child(6)": {
        width: "100px",
      },
      "&:nth-child(7)": {
        width: "100px",
      },
    },
  },
  tableCellData1:{
    width:"25%",
    display:"block",
  },
  tableCellDataEmpty:{
    display:"block",
    width:"125px",
    "@media (max-width:1240px)":{
      width:"100px"
    },
    "@media (max-width:700px)":{
      width:"102px"
    },
  },
  tableHeadCells: {
    borderRight: "2px solid #000000",
    textAlign: "center",
  },
  nextButton:{
    boxShadow:'inherit',
    color:brandTheme.white,
    margin:"10px 10px 10px 0 ",
    letterSpacing:"1px",
    height:"40px",
    // width:"8%",
    padding:'0px 40px',
    width:"100px",
    backgroundColor:brandTheme.buttonColor,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  },
  nextButton1:{
    boxShadow:'inherit',
    color:brandTheme.white,
    margin:"10px 10px 10px 0 ",
    padding:'0px 40px',
    height:"40px",
    // width:"8%",
    width:"100px",
    backgroundColor:brandTheme.button2Color,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  },
  countValue:{
    position: 'absolute',
    top: 48,
    width: '125px',
    transition: 'opacity 0.5s',
    left: -25,
    backgroundColor: '#d3d3d3',
    textAlign: 'center',
    borderRadius: '8px',
    padding: '2px',
    '& span':{
      padding:'0px 6px'
    }
  },
  parentContainer:{
    position:'relative',
    '&:after':{
      content: "",
      position: 'absolute',
      top: 100,
      left: 50,
      marginLeft: '-5px',
      borderWidth: '-5px',
      borderStyle: 'solid',
      borderColor: '#555 transparent transparent transparent',
    }
  },
  erroBorderClass:{
    border: "1px solid red",
  },
  checkboxInput:{
    width: 25,
    height: 70,
  }
});

export default tableStyle;
